  import { Button, Form, message, Space, Checkbox, Table, Col, Row } from "antd";
  import { useEffect, useState, useRef } from "react";
  import { fmtDate, ftmPrice } from "../../extensions/utils";
  import { getTableColumn } from "../../extensions/helper";
  import { DownOutlined, RightOutlined } from "@ant-design/icons";
  import ClientAbonItem from "./client-abon-item";
  import { serverFetch } from "../../server";
  import { renderStatusIcon } from "../../extensions/helper";
  import SaleAdd from "../sales/sale-add";
  import { PaymentAdd } from "../payments";
  import dayjs from "dayjs";
  import { isMobile, menuSize } from "../../extensions/design";
  import ClientItemAbon from "./client-item-abon";

  const ClientAbons = ({ id, finish, exposeOnRefresh }) => {
    const [itemsAbons, setItemsAbons] = useState([]);
    const [itemAbon, setItemAbon] = useState([]);
    const [loading, setLoading] = useState(false);
    const [saleAdd, setSaleAdd] = useState(false);
    const [editId, setEditId] = useState();
    const abonsRef = useRef([]);
    const [expandedRowKeys, setExpandedRowKeys] = useState([]);
    const [showNonClosed, setShowNonClosed] = useState(false);
    const [showNonPayed, setShowNonPayed] = useState(false);
    const [isDataReady, setIsDataReady] = useState(false);
    const [form] = Form.useForm();
    const [item, setItem] = useState({ vid: 0 });
    const [showPayment, setShowPayment] = useState(false);
  
    const getClientData = () => {
      if (id) {
        setLoading(true);
        serverFetch(`client/${id}`)
          .then((data) => {
            if (data.createdOn) data.createdOn = dayjs(data.createdOn);
            if (data.dateBirth) data.dateBirth = dayjs(data.dateBirth);
            data.vid = data.vid === 1;
            setLoading(false);
            setItem(data);
            form.setFieldsValue(data);
          })
          .catch((e) => {
            setLoading(false);
            message.error(e.userName);
          });
      }
    };
    useEffect(getClientData, []);
    const getData = () => {
      if (id) {
        setLoading(true);
        serverFetch(`sale/listbyclient/${id}?vids=${2}&vids=${3}`)
          .then((data) => {
            abonsRef.current = data;
            applyFilter({ showNonClosed, showNonPayed });
            setLoading(false);
            setIsDataReady(true)
          })
          .catch((e) => {
            setLoading(false);
            message.error(e.userMessage || "Ошибка загрузки");
          });
      }
    };
    useEffect(getData, []);

    const onClosePayment = (refresh) => {
      setShowPayment(false);
      refresh && getData();
      getClientData();
    }

    useEffect(() => {
      form.setFieldsValue({ showNonClosed: true });
      applyFilter({ showNonClosed: true });
    }, [isDataReady]);

    const onCloseSaleAdd = (refresh) => {
      setSaleAdd(false);
      refresh && getData();
      getClientData();
    }

    const onSale = () => setSaleAdd(true);

    const onUpdate = (refresh = false) => {
      refresh && setExpandedRowKeys([]);
      getClientData();
      getData();
    };

    useEffect(() => {
      if (exposeOnRefresh) {
        exposeOnRefresh(() => onUpdate);
      }
    }, [exposeOnRefresh]);

    const applyFilter = (values) => {
      const showNonClosed = values.showNonClosed ?? form.getFieldValue("showNonClosed");
      const showNonPayed = values.showNonPayed ?? form.getFieldValue("showNonPayed");

      setShowNonClosed(showNonClosed);
      setShowNonPayed(showNonPayed);

      let filtered = [...abonsRef.current];

      if (showNonClosed) {
        filtered = filtered.filter(item => [1, 2, 3, 4].includes(item.status) && !item.deleted && !item.blocked);
      }

      if (showNonPayed) {
        filtered = filtered.filter(item => item.debet);
      }

      setItemsAbons(filtered);
    };

    const onValuesChange = (changedValues, allValues) => {
      setItemAbon(prev => ({ ...prev, ...changedValues }));
      applyFilter({ ...itemAbon, ...changedValues });
    };

    const columns = [
      getTableColumn("status", "Статус", { render: renderStatusIcon, width: 60 },  itemsAbons),
      getTableColumn("id", "#", { type: "number", defaultSortOrder: "ascend", width: 50 }, itemsAbons),
      /* getTableColumn("visitId", "Визит", { type: "number", width: 100 }, itemsAbons),  */
      getTableColumn("productName", "Наименование", { type: "string", width: 180 }, itemsAbons),
      getTableColumn("syma", "Сумма", { type: "number", width: 70 }, itemsAbons),
      getTableColumn("docDate", "Продажа", { type: "date", width: 75, formatFn: fmtDate }, itemsAbons),
      getTableColumn("finish", "Срок", { type: "date", width: 75, formatFn: fmtDate }, itemsAbons),
      getTableColumn("debet", "Долг", { type: "number", width: 70 }, itemsAbons),
    ];
      const renderedTools = !isMobile ? <>
        <Row>
          <Col span={13}>
            <Row>
              <Space style={{ marginBottom: "8px" }}>
                <Button className="sport-btn" onClick={onSale} disabled={loading || finish}>Продать</Button>
                <Button className="sport-btn" onClick={onUpdate}>Обновить</Button>
                {(!item.clientId && item.dolg) ? <Button onClick={() => setShowPayment(true)} className="dolg-button">Долг {item.dolg}</Button> : null} 
              </Space>
            </Row>
          </Col>
          <Col span={11}>
            <Space>
              <Form.Item name="showNonClosed" valuePropName="checked">
                <Checkbox className="sport-btn">Незакрытые</Checkbox>
              </Form.Item>
              <Form.Item name="showNonPayed" valuePropName="checked">
                <Checkbox className="sport-btn">Неоплаченые</Checkbox>
              </Form.Item>
            </Space>
          </Col>
        </Row>
      </> : <>
        <div className="client-item-line-double-halfed">
          <Form.Item name="showNonClosed" valuePropName="checked"><Checkbox>Незакрытые</Checkbox></Form.Item>
          <Form.Item name="showNonPayed" valuePropName="checked"><Checkbox>Неоплаченые</Checkbox></Form.Item>
        </div>
        <div className="client-item-line-double-halfed" style={{marginBottom:"8px"}}>
          <Button onClick={() => setShowPayment(true)} disabled={!item.dolg} className="pay-debt-mobile">Оплатить {ftmPrice(item.dolg)}</Button>
          <Button onClick={onSale} disabled={loading || finish}>Продать</Button>
        </div>
      </>
      
      const renderedTable = !isMobile ? 
        <div style={{ maxWidth: "100%" }}>
          <Table rowKey="id" dataSource={itemsAbons} loading={loading} columns={columns} size="small" tableLayout="auto"
            pagination={{ position: ["bottomRight"], pageSizeOptions: [10, 25, 50, 100], responsive: true, }}
            className="table-item"
            onRow={(record) => ({
              onClick: () => {
                setEditId(record.id);
                const isExpanded = expandedRowKeys.includes(record.id);
                setExpandedRowKeys(isExpanded ? [] : [record.id]);
              },
            })}
            expandable={{
              expandedRowRender: (record) => <ClientAbonItem id={record.id} status={record.status} abon={record} onAbonsUpdate={(refresh) => onUpdate(refresh)}/>,
              expandedRowKeys: expandedRowKeys,
              onExpand: (expanded, record) => setExpandedRowKeys(expanded ? [record.id] : []),
              expandIcon: ({ expanded, onExpand, record }) =>
                expanded ? (
                  <DownOutlined onClick={(e) => onExpand(record, e)} style={{ cursor: "pointer" }} />
                ) : (
                  <RightOutlined onClick={(e) => onExpand(record, e)} style={{ cursor: "pointer" }} />
                ),
              expandIconColumnIndex: columns.length + 1,
              rowExpandable: () => true,
              className: "cl-abons-expandable",
            }}
            rowSelection={{ type: 'radio', selectedRowKeys: expandedRowKeys, renderCell: checked => <div className={checked ? "list-indicator" : ""} /> }}
          />
        </div>
       : 
        <Form>
          <div className="client-items" style={{ height: window.innerHeight - (menuSize + 91), overflowY: "scroll", overflowX: "clip" }}>
            {itemsAbons.map((item) => {
              const isExpanded = expandedRowKeys.includes(item.id);
              return (
                <div key={item.id}>
                  <div onClick={() => setExpandedRowKeys(isExpanded ? [] : [item.id])} style={{ cursor: "pointer" }}>
                    <ClientItemAbon item={item} expanded={isExpanded} setExpanded={setExpandedRowKeys} onAbonsUpdate={(refresh) => onUpdate(refresh)}/>
                  </div>
                </div>
              );
            })}
            {itemsAbons.length === 0 && !loading && <div style={{ textAlign: "center", marginTop: "20px" }}>Нет данных</div>}
          </div>
        </Form>
        
    return <>
      <Form form={form} labelCol={{ span: 22 }} wrapperCol={{ span: 24 }} colon={false} disabled={loading} onValuesChange={onValuesChange}>
        {renderedTools}
        {renderedTable}
        {saleAdd && <SaleAdd visitId={null} clientId={id} onClose={onCloseSaleAdd} activeBtns={["Абонемент", "Пакет"]} />}
      </Form>
      <div className="payment-window">
          {showPayment && <PaymentAdd clientId={item.id} visitId={null} onClose={() => onClosePayment(true)}/>}
      </div>
    </>
  };
export default ClientAbons;